import { render, staticRenderFns } from "./VinculoUsuarioList.vue?vue&type=template&id=2b84ae77&scoped=true"
import script from "./VinculoUsuarioList.vue?vue&type=script&lang=js"
export * from "./VinculoUsuarioList.vue?vue&type=script&lang=js"
import style0 from "./VinculoUsuarioList.vue?vue&type=style&index=0&id=2b84ae77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b84ae77",
  null
  
)

export default component.exports